
function ParseNumber(num: number){
    if (num >= 1000000) return (Math.round(num / 100000) / 10).toString() + "M"
    if (num >= 1000) return (Math.round(num / 100) / 10).toString() + "K"
    return num
}

export {
    ParseNumber
}